import { createActions } from '../utils/actions';

const { actions: profiles } = createActions('profiles')
  .addAsync('apply')
  .add('bootstrap')
  .add('cleanUp')
  .addAsync('connectListings')
  .addAsync('copy')
  .addAsync('disconnectListing')
  .add('edit')
  .add('editTemplate')
  .add('filter')
  .addAsync('getListings')
  .addAsync('getProfiles')
  .addAsync('remove')
  .addAsync('save')
  .add('search')
  .add('setModal')
  .add('setPage')
  .addAsync('showConnectModal')
  .add('stopWaitingForListings')
  .add('toggleTemplate')
  .add('waitForUploadAndSave');

export default profiles;
